var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'position':'relative','width':_vm.width,'height':_vm.height})},[_c('div',{staticClass:"prism-player",style:(_vm.isHorizontalScreen?{'left':'0'}:_vm.playStyle),attrs:{"id":_vm.playerId}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17087a13","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AliPlayer/index.vue
// module id = null
// module chunks = 